import { useCurrencyFormat, useNumberFormat, usePercentFormat } from 'intl';

export const useColumns = ({ footer }: any) => {
  const numberFormat = useNumberFormat();
  const percentFormat = usePercentFormat();
  const currencyFormat = useCurrencyFormat();

  return [
    {
      accessorKey: 'application',
      header: { id: 'application', name: 'Application' },
      cell: (info: any) => info?.getValue()?.name,
      footer: () => footer?.application?.name,
    },
    {
      accessorKey: 'roasD7',
      header: { id: 'roasD7', name: 'Total ROAS D7' },
      cell: (info: any) => {
        const value = info?.getValue();
        return percentFormat(value);
      },
      footer: () => {
        const value = footer?.roasD7;
        return percentFormat(value);
      },
    },
    {
      accessorKey: 'cpi',
      header: { id: 'cpi', name: 'CPI' },
      cell: (info: any) => {
        const value = info?.getValue();
        return currencyFormat(value?.amount);
      },
      footer: () => {
        const value = footer?.cpi;
        return currencyFormat(value?.amount);
      },
    },
    {
      accessorKey: 'cvr',
      header: { id: 'cvr', name: 'CVR' },
      cell: (info: any) => {
        const value = info?.getValue();
        return percentFormat(value);
      },
      footer: () => {
        const value = footer?.cvr;
        return percentFormat(value);
      },
    },
    {
      accessorKey: 'regs',
      header: { id: 'regs', name: 'Regs' },
      cell: (info: any) => {
        const value = info?.getValue();
        return numberFormat(value);
      },
      footer: () => {
        const value = footer?.regs;
        return numberFormat(value);
      },
    },
    {
      accessorKey: 'spending',
      header: { id: 'spending', name: 'Spend' },
      cell: (info: any) => {
        const value = info?.getValue();
        return currencyFormat(value?.amount);
      },
      footer: () => {
        const value = footer?.spending;
        return currencyFormat(value?.amount);
      },
    },
    {
      accessorKey: 'uaRejectedInstallsByPostAttributionFraud',
      header: {
        id: 'uaRejectedInstallsByPostAttributionFraud',
        name: (
          <div className={'text-align-end'}>
            <div>UA / RE / Total</div>
            <div>Installs by Post-Attr. Fraud</div>
          </div>
        ),
        colSpan: 3,
      },
      cell: (info: any) => {
        const value = info?.getValue();
        return numberFormat(value);
      },
      footer: () => {
        const value = footer?.uaRejectedInstallsByPostAttributionFraud;
        return numberFormat(value);
      },
    },
    {
      accessorKey: 'reRejectedInstallsByPostAttributionFraud',
      header: null,
      cell: (info: any) => {
        const value = info?.getValue();
        return numberFormat(value);
      },
      footer: () => {
        const value = footer?.reRejectedInstallsByPostAttributionFraud;
        return numberFormat(value);
      },
    },
    {
      accessorKey: 'totalRejectedInstallsByPostAttributionFraud',
      header: null,
      cell: (info: any) => {
        const value = info?.getValue();
        return numberFormat(value);
      },
      footer: () => {
        const value = footer?.totalRejectedInstallsByPostAttributionFraud;
        return numberFormat(value);
      },
    },
  ];
};
